import React, { useCallback, useState } from "react";
import { Box, List, ListItem, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useFieldArray, useFormContext } from "react-hook-form";
import i18next from "i18next";
import { getCriterionModel } from "../../../../../services/common/RulesUtils";
import useStyles from "../../../../../style/js-style/containers/administration/rules/RuleFormsStyle";
import CriterionFormFields from "./CriterionFormFields";
import EAButton from "../../../../../components/common/EAButton";
import EAIcon from "components/common/EAIcon";

const CriteriaFormArray = ({
  onCriteriaOrderChange = () => {},
  onSizeChange = () => {},
  readOnly = false
 }) => {
  const { classes } = useStyles();
  const [hoveredLine, setHoveredLine] = useState(null);

  const { control } = useFormContext();

  const { fields: criteria, append, remove, move } = useFieldArray({
    control,
    name: "criteria",
  });

  const onAddEntry = useCallback(() => {
    append(getCriterionModel());
    onSizeChange();
  }, [append, onSizeChange]);

  const handleDragEnd = useCallback((result) => {
    if (result?.destination) {
      move(result.source.index, result.destination.index);
      onCriteriaOrderChange();
    }
  }, [move, onCriteriaOrderChange]);

  return (
    <>
      <DragDropContext onDragEnd={!readOnly && handleDragEnd}>
        <Droppable droppableId="droppable" direction="vertical">
          {(provided) => (
            <List {...provided.droppableProps} ref={provided.innerRef}>
              {criteria?.map((item, index) => {
                return (
                  <Draggable
                    key={item.id}
                    draggableId={`${item.id}`}
                    index={index}
                  >
                    {(provided) => (
                      <ListItem
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            display: 'flex',
                            m: 0,
                            p: 2,
                            bgcolor: 'rgba(242, 243, 247, 0.3)',
                            border: '1px solid',
                            borderColor: 'grey.300',
                            borderRadius: 1,
                            alignItems: 'center'
                          }}
                        >
                          <Box
                            sx={{
                              width: '5%',
                              color: '#C6CBD9',
                            }}
                          >
                            <EAIcon icon={'drag-indicator'} />
                          </Box>
                          {/* TODO : to be added later
                          <Box
                            sx={{
                              width: '5%',
                              color: '#F4B63E',
                              fontFamily: 'Roboto',
                              fontSize: '20px',
                              fontWeight: 600,
                              lineHeight: '24px',
                              letterSpacing: '0.15000000596046448px',
                              textAlign: 'left',
                            }}
                          >
                            {`${index + 1}`}
                          </Box>*/}
                          <Box sx={{ width: '100%' }}
                              onMouseEnter={() => setHoveredLine(index)}
                              onMouseLeave={() => setHoveredLine(null)}
                          >
                            <CriterionFormFields
                              index={index}
                              isHovered={hoveredLine === index}
                              onRemove={() => remove(index)}
                              fieldName={`criteria.${index}`}
                              readOnly={readOnly}
                            />
                          </Box>
                        </Box>
                      </ListItem>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </DragDropContext>

      {/* Add a criterion */}
      {!readOnly &&
        <EAButton
            borderless={true}
            className={classes.addChoiceWrapper}
            onClick={(e) => {
              e.preventDefault();
              onAddEntry();
            }}
            content={
              <div className={classes.addChoiceBtn}>
                <AddIcon style={{ width: "16px", marginRight: "7px" }} />
                <span style={{ fontSize: "12px" }}>
                  {i18next.t("rules.configuration.criteria.actions.addCriterion")}
                </span>
              </div>
            }
          />
      }
    </>
  );
};

export default CriteriaFormArray;
